export default __webpack_public_path__ + "static/media/31.3f80c027.png";